import styled, { css } from 'styled-components/macro';

export const PageHeaderDiv = styled.div`
  margin-top: 20px;
  @media screen and (min-width: 768px) {
    margin-top: 25px;
  }
`;

export const PageHeaderP = styled.p`
  :last-of-type {
    margin-bottom: 50px;
    @media screen and (min-width: 768px) {
      margin-bottom: 30px;
    }
    @media screen and (min-width: 1024px) {
      margin-bottom: 45px;
    }
    @media screen and (min-width: 1440px) {
      margin-bottom: 55px;
    }
  }
  :not(:first-of-type) {
    margin-top: 20px;
  }
  span {
    font-weight: 600;
  }
  ${props =>
    props.mobileCenter &&
    css`
    @media screen and (max-width: 767px) {
      max-width: 425px
      margin: 25px auto;
    }
  `}
`;

export const Subheaderh4 = styled.h4`
  margin-bottom: 12px;
`;

export const SubheaderWithErrorMessageDiv = styled.div`
  ${props =>
    props.hasErrorMessage &&
    css`
      display: flex;
      justify-content: space-between;
      align-items: center;
    `}
`;
